import React from 'react';
import PropTypes from "prop-types";
import NumericSlider from "./NumericSlider";
import NumberFormat from "react-number-format";

function Int(props) {
    const inputRef = React.createRef()
    if (props?.expandedStyle && props.expandedStyle!=='wizard') {
        return <ExpandedInt {...props}/>
    }
    props.elementProps.onKeyPress= function (e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
                return e.target.blur()
            }
            const charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
            const charStr = String.fromCharCode(charCode);
            const digit = (/\d/.test(charStr))
            if (!digit) e.preventDefault();
        }
    props.elementProps.onBlur= function (e) {
            const val = (e.target.value === '') ? 0:parseInt(e.target.value)
            props.setAnswer(val)
        }
    const handleBlur = function (e) {
        let val = e.target.value.replace(/\D/g, '')
        val = val === '' ? 0 : parseInt(val)
        props.setAnswer(val)
    }
    const validity = props.elementProps.isValid ? 'is-valid' : props.elementProps.isInvalid ? 'is-invalid' : ''
    const wizardStyle = props?.expandedStyle === 'wizard' ? 'transitionable delay-2':''
    return <NumberFormat
        defaultValue={props.elementProps.defaultValue === 0 ? 0 : props.elementProps.defaultValue || ''}
        displayType="tel"
        //thousandSeparator={true}
        prefix={props?.prefix}
        suffix={props?.suffix}
        decimalScale={0}
        allowNegative={false}
        className={`${props.elementProps.className} form-control int ${wizardStyle} ${props?.expandedStyle||''} ${validity}`}
        onBlur={handleBlur}
        getInputRef={inputRef}
        onKeyPress={(e)=>{if (e.key === 'Enter' || e.keyCode === 13) {e.target.blur()}}}
    />
   // return (<Form.Control type="tel" {...props.elementProps} />)
}
function ExpandedInt(props) {
    const step = props.elementProps?.step || 1
    const setAnswer = (val)=>{
        props.setAnswer(parseInt(val))
    }

    return <NumericSlider
        prefix={props?.prefix}
        suffix={props?.suffix}
        step={step}
        min={props.elementProps.min}
        max={props.elementProps.max}
        label={props.label}
        setAnswer={setAnswer}
        error={props.elementProps.isInvalid}
        elementProps={{
            defaultValue: props.elementProps.defaultValue || '',
            isValid: props.elementProps.isValid,
            isInvalid: props.elementProps.isInvalid,
        }}
    />
}
Int.propTypes = {
    elementProps: PropTypes.object,
    setAnswer: PropTypes.func
}
export default Int;